import { useTr } from '../../context/langContext';
import LangToggle from '../../components/ui/lang-toggle';
import { ownerStrings } from '../../i18n/owner-strings';
import { webStrings } from '../../i18n/web-strings';

/** The account is allowed in but no outlet is attached to it yet (`OwnerSession.ownerOutletIds` empty). */
export default function NoOutlets({ onSignOut }: { onSignOut: () => void }) {
    const tr = useTr();
    return (
        <div className="relative flex min-h-screen items-center justify-center bg-bg px-6">
            <LangToggle className="absolute right-4 top-4 h-9 rounded-xl border border-line px-3 text-[12.5px] text-ink2" />
            <div className="w-full max-w-md rounded-2xl border border-line bg-surf2 p-7 text-center">
                <p className="text-base font-bold text-ink">{tr(ownerStrings, 'noOutlet')}</p>
                <p className="mt-3 text-sm leading-relaxed text-ink2">
                    {tr(webStrings, 'noOutletBody')}
                </p>
                <button
                    onClick={onSignOut}
                    className="mt-6 h-11 rounded-xl bg-owner px-5 text-sm font-semibold text-white"
                >
                    {tr(ownerStrings, 'signOut')}
                </button>
            </div>
        </div>
    );
}
